// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"24a85d11","693":"c7ac2c10","845":"bbc92826"}[chunkId] + ".chunk.js";
};